import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-c4f19910")
const _hoisted_1 = { class: "padding" }
const _hoisted_2 = ["title"]
const _hoisted_3 = ["title"]
const _hoisted_4 = ["title"]
const _hoisted_5 = ["title"]
const _hoisted_6 = {
  key: 0,
  class: "center padding"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("dig-ui-loader", null, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "center title-1" }
const _hoisted_11 = { class: "project-detail" }
const _hoisted_12 = { class: "bold" }
const _hoisted_13 = { class: "bold" }
const _hoisted_14 = { class: "bold" }
const _hoisted_15 = { class: "bold" }
const _hoisted_16 = {
  key: 0,
  class: "positif"
}
const _hoisted_17 = {
  key: 1,
  class: "negatif"
}
const _hoisted_18 = { class: "bold" }
const _hoisted_19 = {
  key: 0,
  class: "positif"
}
const _hoisted_20 = {
  key: 1,
  class: "negatif"
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_23 = { class: "multiline-text" }
const _hoisted_24 = { key: 1 }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_image_logo = _resolveComponent("base-image-logo")!
  const _component_base_control_grid = _resolveComponent("base-control-grid")!
  const _component_project_form_card = _resolveComponent("project-form-card")!
  const _component_base_card = _resolveComponent("base-card")!

  return (_openBlock(), _createBlock(_component_base_card, { class: "card-project-detail" }, {
    default: _withCtx(() => [
      (!_ctx.editing)
        ? (_openBlock(), _createBlock(_component_base_control_grid, {
            key: 0,
            sideWidth: 130
          }, {
            right: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                (_ctx.isSuperadmin && !_ctx.editing)
                  ? (_openBlock(), _createElementBlock("dig-ui-icon", {
                      key: 0,
                      type: "delete",
                      class: "icon-button",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.deleteProject())),
                      title: _ctx.$t('delete')
                    }, null, 8, _hoisted_2))
                  : _createCommentVNode("", true),
                (!_ctx.editing)
                  ? (_openBlock(), _createElementBlock("dig-ui-icon", {
                      key: 1,
                      type: "show",
                      class: "icon-button",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openLink(_ctx.project?.url))),
                      title: _ctx.$t('onlineAccess')
                    }, null, 8, _hoisted_3))
                  : _createCommentVNode("", true),
                (_ctx.canEdit && !_ctx.editing)
                  ? (_openBlock(), _createElementBlock("dig-ui-icon", {
                      key: 2,
                      type: "edit",
                      class: "icon-button",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editing = true)),
                      title: _ctx.$t('edit')
                    }, null, 8, _hoisted_4))
                  : _createCommentVNode("", true),
                (_ctx.canEdit && _ctx.editing)
                  ? (_openBlock(), _createElementBlock("dig-ui-icon", {
                      key: 3,
                      type: "close",
                      class: "icon-button",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.editing = false)),
                      title: _ctx.$t('cancel')
                    }, null, 8, _hoisted_5))
                  : _createCommentVNode("", true)
              ])
            ]),
            left: _withCtx(() => [
              _createVNode(_component_base_image_logo, {
                src: _ctx.src,
                defaultSrc: "@/assets/default-user.png",
                canEdit: _ctx.canEditImage,
                onLoad: _cache[4] || (_cache[4] = ($event: any) => (_ctx.saveProjectImage($event))),
                onDelete: _cache[5] || (_cache[5] = ($event: any) => (_ctx.deleteProjectImage()))
              }, null, 8, ["src", "canEdit"])
            ]),
            middle: _withCtx(() => [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
                : _createCommentVNode("", true),
              (!_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("dig-ui-title", _hoisted_10, _toDisplayString(_ctx.project?.name || _ctx.$t('project')), 1),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", null, [
                        _createTextVNode(_toDisplayString(_ctx.$t('Project.version')) + " : ", 1),
                        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.project?.version), 1)
                      ]),
                      _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.project?.points) + " pts / " + _toDisplayString(_ctx.$tc('month')), 1),
                      _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.project?.price) + " €HT / " + _toDisplayString(_ctx.$tc('month')), 1),
                      _createElementVNode("div", null, [
                        _createTextVNode(_toDisplayString(_ctx.$t('available')) + " : ", 1),
                        _createElementVNode("span", {
                          class: _normalizeClass(["bold", {
                  positif: (_ctx.getAvailablePoints() || 0) > 0,
                  negatif: (_ctx.getAvailablePoints() || 0) < 0,
                }])
                        }, _toDisplayString(_ctx.getAvailablePoints()) + " pts ", 3)
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        (_ctx.project?.active)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Maintenance activée"))
                          : _createCommentVNode("", true),
                        (!_ctx.project?.active)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Maintenance désactivée"))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        (_ctx.project?.intervention)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_19, "Intervention automatique activée"))
                          : _createCommentVNode("", true),
                        (!_ctx.project?.intervention)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_20, "Intervention automatique désactivée"))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.project?.intervention)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _createElementVNode("div", null, _toDisplayString(_ctx.project.interventionName) + " : " + _toDisplayString(_ctx.project.interventionPoint) + " pts ", 1),
                            _hoisted_22,
                            _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.project.interventionDescription), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_ctx.loading && _ctx.editing)
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
            _createVNode(_component_project_form_card, {
              class: "form",
              title: _ctx.$t('Project.edit'),
              onValidate: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateProject($event))),
              onCancel: _cache[7] || (_cache[7] = ($event: any) => (_ctx.editing = false)),
              disabled: _ctx.disabledFormButton,
              project: _ctx.project
            }, null, 8, ["title", "disabled", "project"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}